@file:OptIn(InternalResourceApi::class)

package ischoolconnect.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ischoolconnect.sharedui.generated.resources/"

@delegate:ResourceContentHash(889_667_092)
internal val Res.drawable.academic_years: DrawableResource by lazy {
      DrawableResource("drawable:academic_years", setOf(
        ResourceItem(setOf(), "${MD}drawable/academic_years.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(229_433_835)
internal val Res.drawable.activity_calendar: DrawableResource by lazy {
      DrawableResource("drawable:activity_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/activity_calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-201_129_109)
internal val Res.drawable.activity_new_school: DrawableResource by lazy {
      DrawableResource("drawable:activity_new_school", setOf(
        ResourceItem(setOf(), "${MD}drawable/activity_new_school.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_743_916_783)
internal val Res.drawable.activity_payment: DrawableResource by lazy {
      DrawableResource("drawable:activity_payment", setOf(
        ResourceItem(setOf(), "${MD}drawable/activity_payment.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_368_004_478)
internal val Res.drawable.activity_ticket: DrawableResource by lazy {
      DrawableResource("drawable:activity_ticket", setOf(
        ResourceItem(setOf(), "${MD}drawable/activity_ticket.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(804_738_777)
internal val Res.drawable.activity_user: DrawableResource by lazy {
      DrawableResource("drawable:activity_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/activity_user.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_623_699_243)
internal val Res.drawable.arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(918_162_095)
internal val Res.drawable.arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-18_711_464)
internal val Res.drawable.arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_020_328_327)
internal val Res.drawable.audit_logs: DrawableResource by lazy {
      DrawableResource("drawable:audit_logs", setOf(
        ResourceItem(setOf(), "${MD}drawable/audit_logs.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_278_850_015)
internal val Res.drawable.ban: DrawableResource by lazy {
      DrawableResource("drawable:ban", setOf(
        ResourceItem(setOf(), "${MD}drawable/ban.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_977_859)
internal val Res.drawable.bell: DrawableResource by lazy {
      DrawableResource("drawable:bell", setOf(
        ResourceItem(setOf(), "${MD}drawable/bell.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_494_652_112)
internal val Res.drawable.blood_drop: DrawableResource by lazy {
      DrawableResource("drawable:blood_drop", setOf(
        ResourceItem(setOf(), "${MD}drawable/blood_drop.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-950_359_014)
internal val Res.drawable.book: DrawableResource by lazy {
      DrawableResource("drawable:book", setOf(
        ResourceItem(setOf(), "${MD}drawable/book.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_058_538_618)
internal val Res.drawable.brand_header_proper: DrawableResource by lazy {
      DrawableResource("drawable:brand_header_proper", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_header_proper.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-606_657_124)
internal val Res.drawable.broadcasts: DrawableResource by lazy {
      DrawableResource("drawable:broadcasts", setOf(
        ResourceItem(setOf(), "${MD}drawable/broadcasts.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_083_407_943)
internal val Res.drawable.building: DrawableResource by lazy {
      DrawableResource("drawable:building", setOf(
        ResourceItem(setOf(), "${MD}drawable/building.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(663_256_454)
internal val Res.drawable.building_school: DrawableResource by lazy {
      DrawableResource("drawable:building_school", setOf(
        ResourceItem(setOf(), "${MD}drawable/building_school.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_176_551_698)
internal val Res.drawable.calendar: DrawableResource by lazy {
      DrawableResource("drawable:calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-608_000_311)
internal val Res.drawable.calendar_grid: DrawableResource by lazy {
      DrawableResource("drawable:calendar_grid", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_grid.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_594_956_493)
internal val Res.drawable.camera: DrawableResource by lazy {
      DrawableResource("drawable:camera", setOf(
        ResourceItem(setOf(), "${MD}drawable/camera.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_672_701_830)
internal val Res.drawable.change_role: DrawableResource by lazy {
      DrawableResource("drawable:change_role", setOf(
        ResourceItem(setOf(), "${MD}drawable/change_role.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-83_298_329)
internal val Res.drawable.chart_square: DrawableResource by lazy {
      DrawableResource("drawable:chart_square", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_square.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-935_919_132)
internal val Res.drawable.check_circle_filled: DrawableResource by lazy {
      DrawableResource("drawable:check_circle_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_circle_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_196_970_540)
internal val Res.drawable.checkbox_checked: DrawableResource by lazy {
      DrawableResource("drawable:checkbox_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/checkbox_checked.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_195_685_462)
internal val Res.drawable.checkbox_checked_role: DrawableResource by lazy {
      DrawableResource("drawable:checkbox_checked_role", setOf(
        ResourceItem(setOf(), "${MD}drawable/checkbox_checked_role.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(598_210_742)
internal val Res.drawable.chevron_down: DrawableResource by lazy {
      DrawableResource("drawable:chevron_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-513_669_026)
internal val Res.drawable.chevron_left: DrawableResource by lazy {
      DrawableResource("drawable:chevron_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_978_131_360)
internal val Res.drawable.chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-517_464_563)
internal val Res.drawable.chevron_up: DrawableResource by lazy {
      DrawableResource("drawable:chevron_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_953_809_344)
internal val Res.drawable.circle_check: DrawableResource by lazy {
      DrawableResource("drawable:circle_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_704_210_605)
internal val Res.drawable.circle_check_outline: DrawableResource by lazy {
      DrawableResource("drawable:circle_check_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_check_outline.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(173_908_282)
internal val Res.drawable.circle_pause: DrawableResource by lazy {
      DrawableResource("drawable:circle_pause", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_pause.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_069_016_438)
internal val Res.drawable.circle_x: DrawableResource by lazy {
      DrawableResource("drawable:circle_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_370_769_477)
internal val Res.drawable.clipboard_check: DrawableResource by lazy {
      DrawableResource("drawable:clipboard_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/clipboard_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_457_403_515)
internal val Res.drawable.clock: DrawableResource by lazy {
      DrawableResource("drawable:clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-104_406_264)
internal val Res.drawable.close_x: DrawableResource by lazy {
      DrawableResource("drawable:close_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/close_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(840_321_540)
internal val Res.drawable.cloud_upload: DrawableResource by lazy {
      DrawableResource("drawable:cloud_upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/cloud_upload.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_909_520_863)
internal val Res.drawable.config: DrawableResource by lazy {
      DrawableResource("drawable:config", setOf(
        ResourceItem(setOf(), "${MD}drawable/config.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_110_173_537)
internal val Res.drawable.crown: DrawableResource by lazy {
      DrawableResource("drawable:crown", setOf(
        ResourceItem(setOf(), "${MD}drawable/crown.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-838_424_366)
internal val Res.drawable.dashboard: DrawableResource by lazy {
      DrawableResource("drawable:dashboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/dashboard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(680_651_297)
internal val Res.drawable.database_download: DrawableResource by lazy {
      DrawableResource("drawable:database_download", setOf(
        ResourceItem(setOf(), "${MD}drawable/database_download.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_492_762_456)
internal val Res.drawable.document: DrawableResource by lazy {
      DrawableResource("drawable:document", setOf(
        ResourceItem(setOf(), "${MD}drawable/document.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(249_946_692)
internal val Res.drawable.double_chevron_left: DrawableResource by lazy {
      DrawableResource("drawable:double_chevron_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/double_chevron_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_025_879_773)
internal val Res.drawable.double_chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:double_chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/double_chevron_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_145_301_055)
internal val Res.drawable.download: DrawableResource by lazy {
      DrawableResource("drawable:download", setOf(
        ResourceItem(setOf(), "${MD}drawable/download.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_184_530_742)
internal val Res.drawable.edit: DrawableResource by lazy {
      DrawableResource("drawable:edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_678_912_131)
internal val Res.drawable.excel_file: DrawableResource by lazy {
      DrawableResource("drawable:excel_file", setOf(
        ResourceItem(setOf(), "${MD}drawable/excel_file.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_058_286_152)
internal val Res.drawable.eye: DrawableResource by lazy {
      DrawableResource("drawable:eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/eye.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_906_292)
internal val Res.drawable.file_spreadsheet: DrawableResource by lazy {
      DrawableResource("drawable:file_spreadsheet", setOf(
        ResourceItem(setOf(), "${MD}drawable/file_spreadsheet.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(374_242_739)
internal val Res.drawable.file_xlsx: DrawableResource by lazy {
      DrawableResource("drawable:file_xlsx", setOf(
        ResourceItem(setOf(), "${MD}drawable/file_xlsx.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(332_078_098)
internal val Res.drawable.filter: DrawableResource by lazy {
      DrawableResource("drawable:filter", setOf(
        ResourceItem(setOf(), "${MD}drawable/filter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_750_997_049)
internal val Res.drawable.folder: DrawableResource by lazy {
      DrawableResource("drawable:folder", setOf(
        ResourceItem(setOf(), "${MD}drawable/folder.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_006_677_313)
internal val Res.drawable.graduation_cap: DrawableResource by lazy {
      DrawableResource("drawable:graduation_cap", setOf(
        ResourceItem(setOf(), "${MD}drawable/graduation_cap.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_285_266_424)
internal val Res.drawable.half_day_evening: DrawableResource by lazy {
      DrawableResource("drawable:half_day_evening", setOf(
        ResourceItem(setOf(), "${MD}drawable/half_day_evening.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-820_620_565)
internal val Res.drawable.half_day_morning: DrawableResource by lazy {
      DrawableResource("drawable:half_day_morning", setOf(
        ResourceItem(setOf(), "${MD}drawable/half_day_morning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_093_764_915)
internal val Res.drawable.headset: DrawableResource by lazy {
      DrawableResource("drawable:headset", setOf(
        ResourceItem(setOf(), "${MD}drawable/headset.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_960_789_397)
internal val Res.drawable.health_backup: DrawableResource by lazy {
      DrawableResource("drawable:health_backup", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_backup.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_657_646_208)
internal val Res.drawable.health_chart: DrawableResource by lazy {
      DrawableResource("drawable:health_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-277_175_313)
internal val Res.drawable.health_database: DrawableResource by lazy {
      DrawableResource("drawable:health_database", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_database.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_262_281_493)
internal val Res.drawable.health_email: DrawableResource by lazy {
      DrawableResource("drawable:health_email", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_email.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(906_779_598)
internal val Res.drawable.health_server: DrawableResource by lazy {
      DrawableResource("drawable:health_server", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_server.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-398_942_181)
internal val Res.drawable.health_sms: DrawableResource by lazy {
      DrawableResource("drawable:health_sms", setOf(
        ResourceItem(setOf(), "${MD}drawable/health_sms.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-197_217_674)
internal val Res.drawable.help_desk: DrawableResource by lazy {
      DrawableResource("drawable:help_desk", setOf(
        ResourceItem(setOf(), "${MD}drawable/help_desk.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(940_009_760)
internal val Res.drawable.hero_scene_without_header: DrawableResource by lazy {
      DrawableResource("drawable:hero_scene_without_header", setOf(
        ResourceItem(setOf(), "${MD}drawable/hero_scene_without_header.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-330_891_932)
internal val Res.drawable.home: DrawableResource by lazy {
      DrawableResource("drawable:home", setOf(
        ResourceItem(setOf(), "${MD}drawable/home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(229_867_014)
internal val Res.drawable.hourglass: DrawableResource by lazy {
      DrawableResource("drawable:hourglass", setOf(
        ResourceItem(setOf(), "${MD}drawable/hourglass.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_367_021_068)
internal val Res.drawable.ic_clock_small: DrawableResource by lazy {
      DrawableResource("drawable:ic_clock_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clock_small.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-873_566_858)
internal val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_586_984_450)
internal val Res.drawable.ic_launcher: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-990_425_980)
internal val Res.drawable.ic_light_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(823_283_672)
internal val Res.drawable.ic_rotate_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_rotate_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rotate_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_535_182_904)
internal val Res.drawable.icon_login_lock: DrawableResource by lazy {
      DrawableResource("drawable:icon_login_lock", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_login_lock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_816_840_676)
internal val Res.drawable.icon_timer_small: DrawableResource by lazy {
      DrawableResource("drawable:icon_timer_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_timer_small.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_054_420_381)
internal val Res.drawable.icon_user_input: DrawableResource by lazy {
      DrawableResource("drawable:icon_user_input", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_user_input.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_514_053_159)
internal val Res.drawable.info_circle: DrawableResource by lazy {
      DrawableResource("drawable:info_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/info_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_212_398_315)
internal val Res.drawable.ischoolconnect_splash_logo: DrawableResource by lazy {
      DrawableResource("drawable:ischoolconnect_splash_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ischoolconnect_splash_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(411_554_434)
internal val Res.drawable.it_users: DrawableResource by lazy {
      DrawableResource("drawable:it_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/it_users.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-580_855_041)
internal val Res.drawable.lock: DrawableResource by lazy {
      DrawableResource("drawable:lock", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(610_126_997)
internal val Res.drawable.logout: DrawableResource by lazy {
      DrawableResource("drawable:logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/logout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_580_215_753)
internal val Res.drawable.mail: DrawableResource by lazy {
      DrawableResource("drawable:mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/mail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(258_132_025)
internal val Res.drawable.map_pin: DrawableResource by lazy {
      DrawableResource("drawable:map_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-338_240_600)
internal val Res.drawable.megaphone: DrawableResource by lazy {
      DrawableResource("drawable:megaphone", setOf(
        ResourceItem(setOf(), "${MD}drawable/megaphone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_346_429_876)
internal val Res.drawable.message: DrawableResource by lazy {
      DrawableResource("drawable:message", setOf(
        ResourceItem(setOf(), "${MD}drawable/message.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-661_171_347)
internal val Res.drawable.more_vertical: DrawableResource by lazy {
      DrawableResource("drawable:more_vertical", setOf(
        ResourceItem(setOf(), "${MD}drawable/more_vertical.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_977_859)
internal val Res.drawable.notifications: DrawableResource by lazy {
      DrawableResource("drawable:notifications", setOf(
        ResourceItem(setOf(), "${MD}drawable/notifications.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(12_902_461)
internal val Res.drawable.open_book: DrawableResource by lazy {
      DrawableResource("drawable:open_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/open_book.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-119_075_223)
internal val Res.drawable.paperclip: DrawableResource by lazy {
      DrawableResource("drawable:paperclip", setOf(
        ResourceItem(setOf(), "${MD}drawable/paperclip.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_460_438_422)
internal val Res.drawable.payments: DrawableResource by lazy {
      DrawableResource("drawable:payments", setOf(
        ResourceItem(setOf(), "${MD}drawable/payments.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(28_427_665)
internal val Res.drawable.pencil: DrawableResource by lazy {
      DrawableResource("drawable:pencil", setOf(
        ResourceItem(setOf(), "${MD}drawable/pencil.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(766_427_868)
internal val Res.drawable.phone: DrawableResource by lazy {
      DrawableResource("drawable:phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_031_987_800)
internal val Res.drawable.phone_call: DrawableResource by lazy {
      DrawableResource("drawable:phone_call", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone_call.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_941_852_701)
internal val Res.drawable.plans: DrawableResource by lazy {
      DrawableResource("drawable:plans", setOf(
        ResourceItem(setOf(), "${MD}drawable/plans.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-814_342_033)
internal val Res.drawable.plus: DrawableResource by lazy {
      DrawableResource("drawable:plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_067_784_621)
internal val Res.drawable.radio_selected: DrawableResource by lazy {
      DrawableResource("drawable:radio_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/radio_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(535_640_921)
internal val Res.drawable.radio_unselected: DrawableResource by lazy {
      DrawableResource("drawable:radio_unselected", setOf(
        ResourceItem(setOf(), "${MD}drawable/radio_unselected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(488_034_490)
internal val Res.drawable.records_list: DrawableResource by lazy {
      DrawableResource("drawable:records_list", setOf(
        ResourceItem(setOf(), "${MD}drawable/records_list.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_885_695_437)
internal val Res.drawable.refresh_cw: DrawableResource by lazy {
      DrawableResource("drawable:refresh_cw", setOf(
        ResourceItem(setOf(), "${MD}drawable/refresh_cw.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_713_425_876)
internal val Res.drawable.reply: DrawableResource by lazy {
      DrawableResource("drawable:reply", setOf(
        ResourceItem(setOf(), "${MD}drawable/reply.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_082_172_208)
internal val Res.drawable.reports: DrawableResource by lazy {
      DrawableResource("drawable:reports", setOf(
        ResourceItem(setOf(), "${MD}drawable/reports.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("academic_years", Res.drawable.academic_years)
  map.put("activity_calendar", Res.drawable.activity_calendar)
  map.put("activity_new_school", Res.drawable.activity_new_school)
  map.put("activity_payment", Res.drawable.activity_payment)
  map.put("activity_ticket", Res.drawable.activity_ticket)
  map.put("activity_user", Res.drawable.activity_user)
  map.put("arrow_left", Res.drawable.arrow_left)
  map.put("arrow_right", Res.drawable.arrow_right)
  map.put("arrow_up", Res.drawable.arrow_up)
  map.put("audit_logs", Res.drawable.audit_logs)
  map.put("ban", Res.drawable.ban)
  map.put("bell", Res.drawable.bell)
  map.put("blood_drop", Res.drawable.blood_drop)
  map.put("book", Res.drawable.book)
  map.put("brand_header_proper", Res.drawable.brand_header_proper)
  map.put("broadcasts", Res.drawable.broadcasts)
  map.put("building", Res.drawable.building)
  map.put("building_school", Res.drawable.building_school)
  map.put("calendar", Res.drawable.calendar)
  map.put("calendar_grid", Res.drawable.calendar_grid)
  map.put("camera", Res.drawable.camera)
  map.put("change_role", Res.drawable.change_role)
  map.put("chart_square", Res.drawable.chart_square)
  map.put("check_circle_filled", Res.drawable.check_circle_filled)
  map.put("checkbox_checked", Res.drawable.checkbox_checked)
  map.put("checkbox_checked_role", Res.drawable.checkbox_checked_role)
  map.put("chevron_down", Res.drawable.chevron_down)
  map.put("chevron_left", Res.drawable.chevron_left)
  map.put("chevron_right", Res.drawable.chevron_right)
  map.put("chevron_up", Res.drawable.chevron_up)
  map.put("circle_check", Res.drawable.circle_check)
  map.put("circle_check_outline", Res.drawable.circle_check_outline)
  map.put("circle_pause", Res.drawable.circle_pause)
  map.put("circle_x", Res.drawable.circle_x)
  map.put("clipboard_check", Res.drawable.clipboard_check)
  map.put("clock", Res.drawable.clock)
  map.put("close_x", Res.drawable.close_x)
  map.put("cloud_upload", Res.drawable.cloud_upload)
  map.put("config", Res.drawable.config)
  map.put("crown", Res.drawable.crown)
  map.put("dashboard", Res.drawable.dashboard)
  map.put("database_download", Res.drawable.database_download)
  map.put("document", Res.drawable.document)
  map.put("double_chevron_left", Res.drawable.double_chevron_left)
  map.put("double_chevron_right", Res.drawable.double_chevron_right)
  map.put("download", Res.drawable.download)
  map.put("edit", Res.drawable.edit)
  map.put("excel_file", Res.drawable.excel_file)
  map.put("eye", Res.drawable.eye)
  map.put("file_spreadsheet", Res.drawable.file_spreadsheet)
  map.put("file_xlsx", Res.drawable.file_xlsx)
  map.put("filter", Res.drawable.filter)
  map.put("folder", Res.drawable.folder)
  map.put("graduation_cap", Res.drawable.graduation_cap)
  map.put("half_day_evening", Res.drawable.half_day_evening)
  map.put("half_day_morning", Res.drawable.half_day_morning)
  map.put("headset", Res.drawable.headset)
  map.put("health_backup", Res.drawable.health_backup)
  map.put("health_chart", Res.drawable.health_chart)
  map.put("health_database", Res.drawable.health_database)
  map.put("health_email", Res.drawable.health_email)
  map.put("health_server", Res.drawable.health_server)
  map.put("health_sms", Res.drawable.health_sms)
  map.put("help_desk", Res.drawable.help_desk)
  map.put("hero_scene_without_header", Res.drawable.hero_scene_without_header)
  map.put("home", Res.drawable.home)
  map.put("hourglass", Res.drawable.hourglass)
  map.put("ic_clock_small", Res.drawable.ic_clock_small)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_launcher", Res.drawable.ic_launcher)
  map.put("ic_light_mode", Res.drawable.ic_light_mode)
  map.put("ic_rotate_right", Res.drawable.ic_rotate_right)
  map.put("icon_login_lock", Res.drawable.icon_login_lock)
  map.put("icon_timer_small", Res.drawable.icon_timer_small)
  map.put("icon_user_input", Res.drawable.icon_user_input)
  map.put("info_circle", Res.drawable.info_circle)
  map.put("ischoolconnect_splash_logo", Res.drawable.ischoolconnect_splash_logo)
  map.put("it_users", Res.drawable.it_users)
  map.put("lock", Res.drawable.lock)
  map.put("logout", Res.drawable.logout)
  map.put("mail", Res.drawable.mail)
  map.put("map_pin", Res.drawable.map_pin)
  map.put("megaphone", Res.drawable.megaphone)
  map.put("message", Res.drawable.message)
  map.put("more_vertical", Res.drawable.more_vertical)
  map.put("notifications", Res.drawable.notifications)
  map.put("open_book", Res.drawable.open_book)
  map.put("paperclip", Res.drawable.paperclip)
  map.put("payments", Res.drawable.payments)
  map.put("pencil", Res.drawable.pencil)
  map.put("phone", Res.drawable.phone)
  map.put("phone_call", Res.drawable.phone_call)
  map.put("plans", Res.drawable.plans)
  map.put("plus", Res.drawable.plus)
  map.put("radio_selected", Res.drawable.radio_selected)
  map.put("radio_unselected", Res.drawable.radio_unselected)
  map.put("records_list", Res.drawable.records_list)
  map.put("refresh_cw", Res.drawable.refresh_cw)
  map.put("reply", Res.drawable.reply)
  map.put("reports", Res.drawable.reports)
}
